/*
 * `html.js` sätts INTE här utan av ett inline-skript först i <head>
 * (layout/theme.liquid). base.css hänger fem regler på klassen — kontroller
 * som bara fungerar med JavaScript visas där, och de som blir överflödiga när
 * JS tar över döljs. En deferred fil som denna kör efter parsningen, så
 * knapparna hade hunnit blinka förbi först.
 */

/*
 * The topic filter is a horizontally scrolling row on narrow screens. When a
 * topic is active, the browser lands at scrollLeft 0 and the selected pill can
 * sit off-screen — so bring it into view without moving the page itself.
 */
(function () {
  var active = document.querySelector('.topics__pill[aria-current]');
  if (!active) return;

  var row = active.closest('.topics');
  if (!row || row.scrollWidth <= row.clientWidth) return;

  var offset = active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  row.scrollTo({ left: Math.max(offset, 0), behavior: reduced ? 'auto' : 'smooth' });
})();

/*
 * Toppradens land-/språkväljare är ett native <details> och fungerar därför
 * utan JavaScript. På desktop lägger skriptet bara till klick-utanför och
 * Escape. Under samma 600px-brytpunkt som kundvagnskvittot blir panelen ett
 * riktigt bottom sheet: fokus stannar i dialogen, bakåtknappen stänger den,
 * sidan låses och fokus återgår till globkontrollen efter stängning.
 *
 * Listorna byggs ur formulärets egna <select>, och ett klick skickar
 * formuläret direkt. Panelen har därför ingen sparknapp och inget mellansteg
 * när JavaScript kör; utan JavaScript är select-fälten och knappen kvar.
 */
(function () {
  var details = document.querySelector('[data-localization-details]');
  if (!details) return;

  var summary = details.querySelector('summary');
  var panel = details.querySelector('[data-localization-panel]');
  var overlay = details.querySelector('[data-localization-overlay]');
  var closeButton = details.querySelector('[data-localization-close]');
  var mobileSheet = window.matchMedia('(max-width: 600px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sheetStatePushed = false;
  var closeTimer = null;
  var localizationForm = details.querySelector('.announcement__localization-form');
  var customPicker = details.querySelector('[data-localization-custom]');
  var isSubmitting = false;

  function normalizedSearchText(value) {
    var text = String(value || '').toLocaleLowerCase();
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text;
  }

  function pickerSelect(kind) {
    if (!localizationForm) return null;
    return localizationForm.querySelector('select[name="' + kind + '_code"]');
  }

  function optionsContainer(kind) {
    return details.querySelector('[data-localization-options="' + kind + '"]');
  }

  function filterPickerOptions(kind, query) {
    var container = optionsContainer(kind);
    var empty = details.querySelector('[data-localization-empty="' + kind + '"]');
    if (!container) return;

    var needle = normalizedSearchText(query);
    var visible = 0;
    Array.prototype.forEach.call(container.querySelectorAll('[data-localization-option]'), function (option) {
      var matches = !needle || option.dataset.search.indexOf(needle) > -1;
      option.hidden = !matches;
      if (matches) visible += 1;
    });
    if (empty) empty.hidden = visible !== 0;
  }

  function resetPickerSearch() {
    Array.prototype.forEach.call(details.querySelectorAll('[data-localization-search]'), function (input) {
      input.value = '';
      filterPickerOptions(input.dataset.localizationSearch, '');
    });
  }

  /* Landslistan är 218 rader i Hjärtgruppens butik. Att öppna den på toppen
     och låta kunden leta upp sitt eget land vore att lägga arbetet på fel
     sida; aktuellt val rullas fram i sin egen behållare. scrollIntoView
     undviks — det flyttar hela sidan bakom panelen. */
  function revealSelectedOptions() {
    Array.prototype.forEach.call(details.querySelectorAll('[data-localization-options]'), function (container) {
      var selected = container.querySelector('[aria-selected="true"]');
      if (!selected || container.scrollHeight <= container.clientHeight) return;

      /* Mät mot behållarens egen kant, inte offsetTop: listan är inte
         positionerad, så offsetParent blir panelen och allt som ligger ovanför
         listan — språkraden, rubriken, sökfältet — räknas då in i offseten.
         Hjärtgruppens Sverige hamnade sex rader ovanför vyn av just det. */
      var delta =
        selected.getBoundingClientRect().top -
        container.getBoundingClientRect().top -
        (container.clientHeight - selected.offsetHeight) / 2;
      container.scrollTop = Math.max(0, container.scrollTop + delta);
    });
  }

  /* Bottom sheeten glider upp i 240 ms. Mäts höjden medan den rör sig blir
     centreringen räknad på en behållare som ännu inte fått sin storlek, så
     samma uträkning körs en gång till när rörelsen är klar. */
  function revealSelectedOptionsWhenSettled() {
    revealSelectedOptions();
    if (reducedMotion.matches) return;
    window.setTimeout(revealSelectedOptions, 260);
  }

  function submitLocalization() {
    if (isSubmitting || !localizationForm) return;
    isSubmitting = true;
    localizationForm.classList.add('is-submitting');
    if (panel) panel.setAttribute('aria-busy', 'true');

    if (typeof localizationForm.requestSubmit === 'function') {
      localizationForm.requestSubmit();
    } else {
      localizationForm.submit();
    }
  }

  function applySelection(kind, value) {
    var select = pickerSelect(kind);
    if (!select) return;

    /* Samma val en gång till är ingen ändring. Att ladda om sidan för det
       ser ut som att något hänt, och kunden tappar sin plats i listningen. */
    if (select.value === value) {
      requestClose();
      return;
    }

    select.value = value;
    submitLocalization();
  }

  function buildPickerOptions(kind) {
    var select = pickerSelect(kind);
    var container = optionsContainer(kind);
    if (!select || !container) return false;

    Array.prototype.forEach.call(select.options, function (sourceOption) {
      var name = sourceOption.dataset.localizationName || sourceOption.textContent.trim();
      var meta = sourceOption.dataset.localizationMeta || '';
      var option = document.createElement('button');
      option.type = 'button';
      option.className = 'announcement__localization-option';
      option.setAttribute('role', 'option');
      option.setAttribute('aria-selected', sourceOption.selected ? 'true' : 'false');
      option.setAttribute('data-localization-option', '');
      option.dataset.value = sourceOption.value;
      option.dataset.search = normalizedSearchText(name + ' ' + meta + ' ' + sourceOption.value);

      var label = document.createElement('span');
      label.textContent = name;
      option.appendChild(label);

      if (meta) {
        var metaLabel = document.createElement('span');
        metaLabel.className = 'announcement__localization-option-meta';
        metaLabel.textContent = meta;
        option.appendChild(metaLabel);
      }

      option.addEventListener('click', function () {
        applySelection(kind, sourceOption.value);
      });
      container.appendChild(option);
    });

    container.addEventListener('keydown', function (event) {
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) === -1) return;
      var options = Array.prototype.slice.call(
        container.querySelectorAll('[data-localization-option]:not([hidden])')
      );
      if (options.length === 0) return;

      var index = options.indexOf(document.activeElement);
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = options.length - 1;
      if (event.key === 'ArrowDown') index = Math.min(index + 1, options.length - 1);
      if (event.key === 'ArrowUp') index = Math.max(index - 1, 0);
      event.preventDefault();
      options[index].focus();
      options[index].scrollIntoView({ block: 'nearest' });
    });

    return true;
  }

  function enhanceLocalizationPicker() {
    if (!localizationForm || !customPicker) return;

    /* Bara dimensioner med mer än ett värde renderas av Liquid. Saknas
       sektionen finns inget att bygga, och panelen står kvar med sin
       förklaring i stället för en låst kontroll. */
    var built = false;
    ['language', 'country'].forEach(function (kind) {
      if (optionsContainer(kind) && buildPickerOptions(kind)) built = true;
    });
    if (!built) return;

    Array.prototype.forEach.call(details.querySelectorAll('[data-localization-search]'), function (input) {
      input.addEventListener('input', function () {
        filterPickerOptions(input.dataset.localizationSearch, input.value);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown') return;
        var section = input.closest('.announcement__localization-section');
        var first = section && section.querySelector('[data-localization-option]:not([hidden])');
        if (!first) return;
        event.preventDefault();
        first.focus();
      });
    });

    customPicker.hidden = false;
    localizationForm.classList.add('is-enhanced');
  }

  enhanceLocalizationPicker();

  function focusableIn(container) {
    return Array.prototype.slice
      .call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      )
      .filter(function (element) {
        return element.offsetParent !== null;
      });
  }

  function pushSheetState() {
    if (sheetStatePushed) return;
    try {
      window.history.pushState({ localizationSheet: true }, '');
      sheetStatePushed = true;
    } catch (error) {
      /* Sandboxade förhandsvisningar kan neka history; stängning fungerar ändå. */
    }
  }

  function openSheet() {
    if (!details.open || !mobileSheet.matches || !panel) return;

    document.documentElement.classList.add('localization-sheet-open');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    var heading = details.querySelector('.announcement__localization-heading');
    if (heading && heading.id) panel.setAttribute('aria-labelledby', heading.id);
    pushSheetState();

    window.setTimeout(function () {
      if (!details.open || !panel) return;
      panel.focus({ preventScroll: true });
      revealSelectedOptionsWhenSettled();
    }, 0);
  }

  function clearSheetState(restoreFocus) {
    window.clearTimeout(closeTimer);
    closeTimer = null;
    details.classList.remove('is-closing');
    document.documentElement.classList.remove('localization-sheet-open');

    if (panel) {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('aria-labelledby');
    }

    resetPickerSearch();

    if (restoreFocus && summary) summary.focus();
  }

  function finishClose() {
    details.open = false;
    clearSheetState(true);
  }

  function closeSheet() {
    if (!details.open) return;
    details.classList.add('is-closing');

    if (reducedMotion.matches) {
      finishClose();
      return;
    }

    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(finishClose, 220);
  }

  function requestClose() {
    if (sheetStatePushed) {
      window.history.back();
    } else {
      closeSheet();
    }
  }

  window.addEventListener('popstate', function () {
    if (!sheetStatePushed) return;
    sheetStatePushed = false;
    closeSheet();
  });

  details.addEventListener('toggle', function () {
    if (details.open) {
      if (mobileSheet.matches) {
        openSheet();
      } else {
        /* På telefon får sökfältet inte fokus: tangentbordet hade då lagt
           sig över listan innan kunden ens sett den. Desktop har ingen
           sådan kostnad och tjänar på att kunna skriva direkt. */
        var search = details.querySelector('[data-localization-search]');
        if (search) {
          window.setTimeout(function () {
            if (details.open) search.focus({ preventScroll: true });
          }, 0);
        }
      }
      revealSelectedOptionsWhenSettled();
      return;
    }

    clearSheetState(false);
  });

  if (summary) {
    summary.addEventListener('click', function (event) {
      if (!details.open || !mobileSheet.matches) return;
      event.preventDefault();
      requestClose();
    });
  }

  if (overlay) overlay.addEventListener('click', requestClose);
  if (closeButton) closeButton.addEventListener('click', requestClose);

  document.addEventListener('click', function (event) {
    if (!details.open || mobileSheet.matches || details.contains(event.target)) return;
    details.open = false;
  });

  details.addEventListener('keydown', function (event) {
    if (!details.open) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      if (mobileSheet.matches) {
        requestClose();
      } else {
        details.open = false;
        if (summary) summary.focus();
      }
      return;
    }

    if (event.key !== 'Tab' || !mobileSheet.matches || !panel) return;

    var focusable = focusableIn(panel);
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (document.activeElement === panel || !panel.contains(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
      return;
    }

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function handleMobileSheetChange() {
    if (!details.open) return;
    if (mobileSheet.matches) {
      openSheet();
    } else {
      requestClose();
    }
  }

  if (mobileSheet.addEventListener) {
    mobileSheet.addEventListener('change', handleMobileSheetChange);
  } else {
    mobileSheet.addListener(handleMobileSheetChange);
  }

  if (details.open && mobileSheet.matches) openSheet();
})();

/*
 * Header predictive search. The form already submits to a real search
 * results page (see sections/header.liquid) — this only adds a suggestion
 * dropdown on top, fed by Shopify's predictive search endpoint. Without JS,
 * or if the endpoint errors, the form just submits like a normal search box.
 */
(function () {
  var form = document.querySelector('[data-predictive-search]');
  if (!form) return;

  var input = form.querySelector('input[type="search"]');
  var resultsEl = form.querySelector('[data-predictive-search-results]');
  var endpoint = form.dataset.predictiveSearchUrl;
  if (!input || !resultsEl || !endpoint) return;

  var panel = form.querySelector('[data-search-panel]');
  var idleEl = form.querySelector('[data-search-idle]');
  var backButton = form.querySelector('[data-search-back]');
  var historyGroup = form.querySelector('[data-search-history]');
  var historyList = form.querySelector('[data-search-history-list]');
  var clearButton = form.querySelector('[data-search-clear]');
  var bar = document.querySelector('.header__bar');

  var HISTORY_KEY = 'search-history';
  var HISTORY_MAX = 5;

  /*
   * Sökhistoriken ligger i localStorage och lämnar aldrig webbläsaren. Den är
   * besökarens egna termer, inte butiksdata — och privat läge kan blockera
   * lagringen helt, så varje anrop måste tåla att kasta. Faller den bort visas
   * bara populära sökningar, vilket är ett fullgott utgångsläge.
   */
  function readHistory() {
    try {
      var raw = JSON.parse(localStorage.getItem(HISTORY_KEY));
      return Array.isArray(raw) ? raw.filter(function (t) { return typeof t === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(terms) {
    try {
      localStorage.setItem(HISTORY_KEY, JSON.stringify(terms.slice(0, HISTORY_MAX)));
    } catch (e) {
      /* Ingen lagring tillgänglig — historiken gäller då bara sidvisningen. */
    }
  }

  function rememberTerm(term) {
    var clean = term.trim();
    if (clean.length < 2) return;
    var terms = readHistory().filter(function (t) {
      return t.toLowerCase() !== clean.toLowerCase();
    });
    terms.unshift(clean);
    writeHistory(terms);
  }

  function searchUrlFor(term) {
    var typeField = form.querySelector('input[name="type"]');
    var types = typeField ? typeField.value : 'product,article,page';
    return form.action + '?q=' + encodeURIComponent(term) + '&type=' + encodeURIComponent(types);
  }

  function renderHistory() {
    if (!historyGroup || !historyList) return;
    var terms = readHistory();
    historyList.innerHTML = '';

    /* Före den tidiga returen: rensas historiken måste de populära raderna
       som doldes som dubbletter komma tillbaka. */
    hidePopularDuplicates(terms);

    if (terms.length === 0) {
      historyGroup.hidden = true;
      return;
    }

    terms.forEach(function (term) {
      var link = document.createElement('a');
      link.className = 'header__panel-row';
      link.href = searchUrlFor(term);

      /* Ikonen klonas ur en serverrenderad rad i stället för att byggas som
         en SVG-sträng här — då finns markupen på ett ställe, och en ändring i
         snippets/icon.liquid slår igenom även på de här raderna. */
      var template = idleEl && idleEl.querySelector('.header__suggest-media');
      if (template) link.appendChild(template.cloneNode(true));

      var label = document.createElement('span');
      label.textContent = term;
      link.appendChild(label);
      historyList.appendChild(link);
    });

    historyGroup.hidden = false;
  }

  /*
   * En term som besökaren just sökt på står redan överst i historiken — då är
   * samma rad under "Populära sökningar" bara upprepning som trycker ner
   * kategorierna under vecket. Raderna döljs, inte tas bort: rensas historiken
   * ska de tillbaka utan att sidan laddas om.
   */
  function hidePopularDuplicates(terms) {
    if (!idleEl) return;
    var lower = terms.map(function (t) { return t.toLowerCase(); });
    Array.prototype.forEach.call(idleEl.querySelectorAll('[data-popular-term]'), function (row) {
      row.hidden = lower.indexOf(row.dataset.popularTerm.toLowerCase()) > -1;
    });
  }

  /*
   * Sökläget på mobil. Klassen på .header__bar gömmer logotyp och ikoner och
   * ger sökraden hela bredden plus en bakåtknapp — se base.css. På desktop gör
   * klassen ingenting (reglerna ligger i mobilens media query), så samma kod
   * kan köra på båda utan en breddkontroll som ändå skulle bli fel vid rotation.
   */
  function openSearchMode() {
    if (bar) bar.classList.add('header__bar--searching');
    if (backButton) backButton.hidden = false;
    positionPanel();
  }

  /*
   * Panelen ligger `fixed` på mobil för att gå kant till kant utan att bry sig
   * om headerns page-width-marginaler. Då måste överkanten sättas här — den är
   * headerns faktiska underkant, som varierar med toppraden och med om
   * besökaren scrollat. Läses om vid scroll och rotation.
   */
  function positionPanel() {
    if (!panel || !bar) return;
    var header = bar.closest('header') || bar.parentElement;
    var bottom = (header || bar).getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--search-panel-top', Math.max(0, Math.round(bottom)) + 'px');
  }

  function closeSearchMode() {
    if (bar) bar.classList.remove('header__bar--searching');
    if (backButton) backButton.hidden = true;
    if (panel) panel.hidden = true;
    if (idleEl) idleEl.hidden = true;
    render([]);
  }

  /* Combobox-rollen sätts här och inte i Liquid: utan JavaScript finns ingen
     förslagslista, och en `role="combobox"` med `aria-expanded="false"` hade
     lovat en kontroll som aldrig kommer. */
  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-expanded', 'false');
  if (resultsEl.id) input.setAttribute('aria-controls', resultsEl.id);

  var debounceTimer = null;
  var controller = null;

  /* The currently rendered <a role="option"> elements and which one (if
     any) is the active descendant — kept in sync with aria-activedescendant
     on the input so focus never actually leaves it, per the ARIA combobox
     pattern. */
  var items = [];
  var activeIndex = -1;

  var KIND_LABELS = {
    product: 'Produkt',
    collection: 'Kategori',
    article: 'Guide',
  };

  function setActive(index) {
    if (items[activeIndex]) {
      items[activeIndex].setAttribute('aria-selected', 'false');
    }

    activeIndex = index;

    if (items[activeIndex]) {
      items[activeIndex].setAttribute('aria-selected', 'true');
      items[activeIndex].scrollIntoView({ block: 'nearest' });
      input.setAttribute('aria-activedescendant', items[activeIndex].id);
    } else {
      input.removeAttribute('aria-activedescendant');
    }
  }

  /*
   * Panelen har två lägen som aldrig visas samtidigt: utgångsläget (historik
   * + populärt, serverrenderat i sections/header.liquid) när fältet är tomt,
   * och förslagslistan när det finns text. `showIdle` växlar mellan dem och
   * fäller hela panelen när det inte finns något att visa i något av dem.
   */
  function showIdle(idle) {
    if (!panel) return;
    if (idleEl) idleEl.hidden = !idle;
    if (idle) {
      resultsEl.hidden = true;
      panel.hidden = !idleHasContent();
    }
  }

  function idleHasContent() {
    if (!idleEl) return false;
    return Array.prototype.some.call(idleEl.children, function (child) {
      return !child.hidden;
    });
  }

  /*
   * Rutan längst till vänster på en förslagsrad: produktens bild, eller
   * kategorins/guidens ikon. Ikonerna klonas ur <template data-suggest-icons>
   * i header.liquid — skriptet kan inte rendera Liquid, och samma SVG i en
   * JS-sträng hade driftat isär från snippets/icon.liquid vid nästa justering.
   */
  var iconTemplate = form.querySelector('[data-suggest-icons]');

  function media(item) {
    var box = document.createElement('span');
    box.className = 'header__suggest-media';

    if (item.type === 'product' && item.image) {
      var img = document.createElement('img');
      /* `width=88` räcker för en 44 px-ruta på 2x. Shopifys bild-URL:er tar
         parametern direkt; utan den hämtas originalet, som här kan vara
         2000 px brett per rad i en lista som byts vid varje tangenttryck. */
      img.src = item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=88';
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      box.appendChild(img);
      return box;
    }

    var source = iconTemplate &&
      iconTemplate.content.querySelector('[data-icon="' + item.type + '"] svg');
    if (source) box.appendChild(source.cloneNode(true));
    return box;
  }

  function render(results) {
    resultsEl.innerHTML = '';
    items = [];
    activeIndex = -1;
    input.removeAttribute('aria-activedescendant');

    if (results.length === 0) {
      resultsEl.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = !(idleEl && !idleEl.hidden && idleHasContent());
      return;
    }

    results.forEach(function (item, index) {
      var link = document.createElement('a');
      link.href = item.url;
      link.className = 'header__suggest-item';
      link.id = 'header-suggest-option-' + index;
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');

      link.appendChild(media(item));

      /* Typen stod som en versalsatt textkolumn till 2026-08-07. Den bär
         ingen information som bilden eller ikonen inte redan ger, men den
         behövs fortfarande för den som lyssnar på listan i stället för att
         se den — därav dold, inte borttagen. */
      var kind = document.createElement('span');
      kind.className = 'visually-hidden';
      kind.textContent = item.kind + ': ';

      var label = document.createElement('span');
      label.className = 'header__suggest-label';
      label.textContent = item.label;

      link.appendChild(kind);
      link.appendChild(label);
      resultsEl.appendChild(link);
      items.push(link);
    });

    if (idleEl) idleEl.hidden = true;
    resultsEl.hidden = false;
    if (panel) panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function search(term) {
    if (controller) controller.abort();
    controller = new AbortController();

    var url =
      endpoint +
      '?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product,collection,article&resources[limit]=10' +
      /* Shopifys standardfält utelämnar SKU. Behåll standarduppsättningen
         och lägg till artikelnumret uttryckligen; annars fungerar SKU först
         när formuläret skickas till den fullständiga söksidan. */
      '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku';

    /* ⚠️ `resources[limit]` är ett TOTALT tak över alla typer, inte ett tak per
     * typ som namnet antyder. Mätt 2026-08-07 på "laerdal": limit 6 gav 5
     * produkter + 1 kategori, limit 10 gav 9 + 1. Med 6 fick kvoterna nedan
     * aldrig något att välja mellan.
     *
     * Kvoterna nedan är hela poängen med den här funktionen.
     *
     * Listan byggdes tidigare produkter-först och kapades vid sex. Ett
     * varumärke som Laerdal har långt fler än sex produkter som bär namnet i
     * titeln, så kategorin trängdes ut av sina egna produkter varje gång —
     * alltså precis på de sökningar där kategorin är det bästa svaret.
     *
     * Kategorierna går först och inte bara med garanterad plats: de är en
     * bredare ingång än en enskild produkt, och den som söker på ett
     * varumärke eller en produkttyp vill nästan alltid till listan. */
    var QUOTA = { collections: 3, products: 6, articles: 2 };

    fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
      .then(function (response) {
        /* Svarar endpointen med en HTML-felsida är det ingen idé att köra den
           genom JSON-parsern — kasta direkt till .catch, som fäller listan och
           lämnar kvar sökrutan som den vanliga sökruta den är utan JS. */
        if (!response.ok) throw new Error('predictive search: ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var resources = (data && data.resources && data.resources.results) || {};
        var results = [];

        (resources.collections || []).slice(0, QUOTA.collections).forEach(function (c) {
          results.push({ type: 'collection', kind: KIND_LABELS.collection, label: c.title, url: c.url });
        });
        (resources.products || []).slice(0, QUOTA.products).forEach(function (p) {
          /* Kategorier och guider bär också bild i svaret, men får ikon: en
             kategori ÄR en lista och ska inte representeras av en enda av sina
             produkter. Bilden är produktradens särskiljare, inte listans. */
          results.push({ type: 'product', kind: KIND_LABELS.product, label: p.title, url: p.url, image: p.image });
        });
        (resources.articles || []).slice(0, QUOTA.articles).forEach(function (a) {
          results.push({ type: 'article', kind: KIND_LABELS.article, label: a.title, url: a.url });
        });

        render(results);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') resultsEl.hidden = true;
      });
  }

  input.addEventListener('focus', function () {
    openSearchMode();
    if (input.value.trim().length < 2) {
      renderHistory();
      showIdle(true);
    }
  });

  input.addEventListener('input', function () {
    var term = input.value.trim();
    window.clearTimeout(debounceTimer);

    if (term.length < 2) {
      render([]);
      renderHistory();
      showIdle(true);
      return;
    }

    debounceTimer = window.setTimeout(function () {
      search(term);
    }, 200);
  });

  /*
   * Blur stänger INTE längre panelen. På mobil tar tangentbordet fokus så
   * fort besökaren scrollar i förslagen, och den gamla 150 ms-timern fällde
   * då ihop listan mitt under fingret. Panelen stängs i stället av det som
   * faktiskt betyder "jag är klar": bakåtknappen, Escape, ett klick utanför
   * headern, eller en submit.
   */
  if (backButton) {
    backButton.addEventListener('click', function () {
      input.value = '';
      closeSearchMode();
      input.blur();
    });
  }

  if (clearButton) {
    clearButton.addEventListener('click', function () {
      writeHistory([]);
      renderHistory();
      /* Panelen kan bli tom när historiken var det enda som fanns. */
      showIdle(true);
      input.focus();
    });
  }

  document.addEventListener('click', function (event) {
    if (!panel || panel.hidden) return;
    if (form.contains(event.target)) return;
    closeSearchMode();
  });

  window.addEventListener('scroll', function () {
    if (panel && !panel.hidden) positionPanel();
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (panel && !panel.hidden) positionPanel();
  });

  form.addEventListener('submit', function () {
    rememberTerm(input.value);
  });

  /*
   * Combobox keyboard support. Focus stays on the input the whole time —
   * ArrowUp/Down move a virtual "active descendant" through the listbox
   * (tracked via aria-activedescendant, see setActive above) rather than
   * moving real DOM focus onto the option links.
   */
  input.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeSearchMode();
      return;
    }

    if (resultsEl.hidden || items.length === 0) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setActive(activeIndex + 1 >= items.length ? 0 : activeIndex + 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setActive(activeIndex - 1 < 0 ? items.length - 1 : activeIndex - 1);
    } else if (event.key === 'Enter' && activeIndex > -1) {
      /* An option is active: go there instead of submitting the form with
         the raw search term. With no active option, Enter falls through to
         the form's normal submit — the search results page. */
      event.preventDefault();
      window.location.href = items[activeIndex].href;
    }
  });
})();

/* --------------------------------------------------------------------------
   Lägesväxlare (ljust/mörkt)

   Klicket sätter motsatsen till det EFFEKTIVA läget — alltså besökarens
   explicita val om det finns, annars systemets. Utan det steget gör första
   klicket ingenting för den som kör mörkt systemläge: koden hade läst ett
   tomt data-theme, gissat "ljust" och satt "mörkt", vilket redan gällde.

   Grundläget bärs av `prefers-color-scheme` i base.css och av inline-skriptet
   i layout/theme.liquid. Den här filen är `defer`:ad och kan därför inte
   ansvara för utseendet vid första målningen — bara för bytet.
   -------------------------------------------------------------------------- */
(function () {
  var root = document.documentElement;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-theme-toggle]');
    if (!button) return;

    var explicit = root.dataset.theme;
    var effective =
      explicit === 'dark' || explicit === 'light'
        ? explicit
        : window.matchMedia('(prefers-color-scheme: dark)').matches
          ? 'dark'
          : 'light';
    var next = effective === 'dark' ? 'light' : 'dark';

    root.dataset.theme = next;
    try {
      localStorage.setItem('theme', next);
    } catch (e) {
      /* Privat läge kan blockera localStorage — valet gäller då sidvisningen. */
    }
  });
})();

/* --------------------------------------------------------------------------
   Mobilmenyn — behåll läsplatsen när lådan stängs

   Lådan öppnas och stängs med `:target` (se base.css § menu-drawer), alltså
   med riktig fragmentnavigering: hamburgaren pekar på `#huvudmeny`, stäng och
   scrim pekar på `#main`. Tekniken är vald för att menyn ska fungera utan
   JavaScript, och det ska den fortsätta göra.

   Bieffekten är att STÄNGNINGEN flyttar sidan. Att navigera till `#main`
   lägger huvudinnehållets överkant vid viewportens överkant, så besökaren
   landar på exakt samma punkt varje gång — 165 px in i dokumentet, precis
   under den `sticky` headern — oavsett var hen läste. Uppmätt på produktsidan
   2026-08-05: 0 → 165, 60 → 165, 400 → 165. Nära toppen känns det som att
   sidan glidit ner en bit; längre ner är det ett hopp uppåt och läsplatsen är
   borta. ÖPPNINGEN flyttar däremot ingenting, eftersom `#huvudmeny` är
   `position: fixed` och redan syns.

   Fixen låter navigeringen ske som vanligt och lägger tillbaka scrollen i
   samma bildruta, före målning — inget hopp syns. `history.pushState` vore
   snyggare men går inte: den uppdaterar INTE `:target`, verifierat i både
   WebKit och Chromium, så lådan hade slutat öppna sig.

   Alla lådans fragmentlänkar täcks, inte bara `#main`. Nivåbytena inuti lådan
   rör visserligen bara `position: fixed`-innehåll och scrollar därför
   ingenting i dag, men det gäller bara så länge lådan ÄR fixed — och den
   kostnaden är noll.
   -------------------------------------------------------------------------- */
(function () {
  if (!document.getElementById('huvudmeny')) return;

  /* Capture-fasen: körs före eventuella andra klicklyssnare, men fortfarande
     före webbläsarens egen fragmentnavigering — den sker först när eventet är
     färdigdistribuerat. */
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href^="#huvudmeny"], a[href="#main"]');
      if (!link) return;

      var y = window.scrollY;
      window.requestAnimationFrame(function () {
        if (Math.round(window.scrollY) !== Math.round(y)) window.scrollTo(0, y);
      });
    },
    true
  );
})();

/*
 * Brödsmulan fälls ihop från VÄNSTER när den inte ryms, i stället för att
 * korta av sista posten. Steget man står på och dess närmaste förälder är det
 * som säger var man är; "Hem" är det man minst behöver läsa. Mönstret är
 * IKEA:s — deras markup bär hela stigen och avkortningen sker i klienten.
 *
 * Utan den här filen renderas hela stigen och kortas i värsta fall av på
 * sista posten via CSS. Inget går sönder, raden blir bara mindre elegant.
 */
(function () {
  var lists = Array.prototype.slice.call(document.querySelectorAll('[data-breadcrumbs]'));
  if (!lists.length) return;

  lists.forEach(function (list) {
    var more = list.querySelector('[data-breadcrumbs-more]');
    if (!more) return;

    var items = Array.prototype.slice.call(list.children).filter(function (li) {
      return li !== more;
    });
    /* En stig med bara "Hem" och sidan själv har inget att falla ihop: den
       sista posten rörs aldrig, och då återstår en enda kandidat vars
       ihopfällning ger `… › Sidan` — kortare, men inte mer läsbart. */
    if (items.length < 3) return;

    /* 1 px slack: scrollWidth och clientWidth är avrundade heltal och kan
       skilja sig med en subpixel på en rad som i praktiken ryms. */
    function fits() {
      return list.scrollWidth <= list.clientWidth + 1;
    }

    /* IKEA gömmer sidan man STÅR PÅ ur den synliga smulan på mobil: deras
       "Matlådor & lunchlådor"-sida visar `… › Köksutrustning & dukning ›
       Matförvaring & köksförvaring`, alltså föräldern sist. Poängen är att
       sidans namn redan står som h1 tjugo pixlar under — utan det blir raden
       en upprepning av rubriken, vilket är precis vad vår 390 px-vy blev.

       Villkoret `>= 3` är vårt eget och inte IKEA:s. Deras stigar är fyra–fem
       steg djupa; våra hubbar är två (Hem › Hjärtstartare), och där hade
       regeln lämnat ett ensamt "Hem". Sidan göms alltså bara när det finns
       minst två steg kvar att visa. */
    function hideSelfOnMobile() {
      return items.length >= 3 && window.matchMedia('(max-width: 899px)').matches;
    }

    /* Vilken post som är "den sista" beror på läget: på desktop sidan man
       står på, på mobil föräldern. CSS kan inte välja sista ICKE-hopfällda
       barnet, så markeringen sätts här. */
    function markLastVisible() {
      items.forEach(function (li) {
        li.classList.remove('is-last-visible');
      });
      for (var i = items.length - 1; i >= 0; i--) {
        if (!items[i].classList.contains('is-collapsed')) {
          items[i].classList.add('is-last-visible');
          return;
        }
      }
    }

    function sync() {
      items.forEach(function (li) {
        li.classList.remove('is-collapsed');
      });
      more.hidden = true;
      if (hideSelfOnMobile()) items[items.length - 1].classList.add('is-collapsed');
      markLastVisible();
      /* Avkortningen av sista posten stängs av under mätningen. Med den på
         krymper posten sig själv till radbredden, scrollWidth blir lika med
         clientWidth och fits() svarar ja på varje sida — se base.css. */
      list.classList.remove('is-truncating');
      if (fits()) return;

      /* Aldrig den sista SYNLIGA posten. På desktop är det sidan man står på;
         på mobil är den redan gömd och sista synliga är föräldern. Ryms inte
         ens den ensam tar CSS:ens text-overflow vid. */
      var last = hideSelfOnMobile() ? items.length - 2 : items.length - 1;
      for (var i = 0; i < last; i++) {
        items[i].classList.add('is-collapsed');
        more.hidden = false;
        markLastVisible();
        if (fits()) return;
      }

      list.classList.add('is-truncating');
    }

    sync();

    /* Teckensnittet byter från fallbacken till Instrument Sans efter att
       filen körts, och raden blir då en annan bredd. Utan det här mäts stigen
       en gång på fel typsnitt. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    window.addEventListener('resize', sync);
  });
})();

/*
 * Offert- och kontaktmejl som mätpunkt.
 *
 * Butiken har medvetet ingen telefonsupport (borttagen 2026-08-03), så mejl ÄR
 * B2B-kanalen: offertlänken på produktsidan, "Mejla er lista" från
 * prisunderlaget, kontaktadressen i sidhuvud och sidfot. Fram till 2026-08-20
 * mättes ingen av dem, och Google Ads bjöd därför som om den trafiken var
 * värdelös — trots att en hjärtstartare till en arbetsplats rimligen börjar som
 * en offertförfrågan och inte som en kassa.
 *
 * En enda delegerad lyssnare täcker alla mailto-länkar i temat. Klassificeringen
 * sker på klassnamn, inte på adressen: samma adress används för både offert och
 * allmänna frågor, så adressen säger ingenting om avsikten.
 *
 * ⚠️ Ett mailto-klick lämnar INTE sidan — mejlklienten öppnas vid sidan av. Det
 *    finns alltså inget unload-race att skydda mot, och `sendBeacon` behövs inte.
 *    Men klicket kan heller inte verifieras: att någon öppnade sitt mejlprogram
 *    är inte samma sak som att de skickade något. Händelsen är en INTENTION och
 *    ska värderas därefter — det inskickade formuläret är det riktiga kvittot.
 */
(function () {
  function publish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('hjartgruppen:' + name, payload || {});
      }
    } catch (_error) {
      /* Mätning får aldrig hindra att kunden når sitt mejlprogram. */
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href^="mailto:"]') : null;
    if (!link) return;

    if (link.classList.contains('pdp-buy__quote')) {
      publish('offert_mejl_oppnat', {
        placement: 'produktsida',
        product_id: link.getAttribute('data-quote-product-id') || null,
        product_title: link.getAttribute('data-quote-title') || null,
        sku: link.getAttribute('data-quote-sku') || null
      });
      return;
    }

    if (link.classList.contains('cart__empty-link') || link.closest('.saved-products')) {
      publish('lista_mejlad', { placement: 'prisunderlag' });
      return;
    }

    /* Allt annat är en allmän kontaktväg. `data-mailto-placement` sätts där
       platsen är värd att skilja på; utan attributet duger sektionens id. */
    var section = link.closest('[data-section-type], .shopify-section');
    publish('kontakt_mejl_oppnat', {
      placement: link.getAttribute('data-mailto-placement') ||
        (section ? section.id || section.getAttribute('data-section-type') : 'okand')
    });
  });
})();
